var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoDrag = function SvgIcoDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#EEE",
    fillOpacity: 0.5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.571 14.286a1.143 1.143 0 1 1 2.286 0 1.143 1.143 0 0 1-2.286 0M8.571 9.714a1.143 1.143 0 1 1 2.286 0 1.143 1.143 0 0 1-2.286 0M8.571 5.143a1.143 1.143 0 1 1 2.286 0 1.143 1.143 0 0 1-2.286 0M8.571 18.857a1.143 1.143 0 1 1 2.286 0 1.143 1.143 0 0 1-2.286 0M13.144 14.286a1.143 1.143 0 1 1 2.285 0 1.143 1.143 0 0 1-2.285 0M13.144 9.714a1.143 1.143 0 1 1 2.285 0 1.143 1.143 0 0 1-2.285 0M13.144 5.143a1.143 1.143 0 1 1 2.285 0 1.143 1.143 0 0 1-2.285 0M13.144 18.857a1.143 1.143 0 1 1 2.285 0 1.143 1.143 0 0 1-2.285 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoDrag;